import { render } from "./AboutS4.vue?vue&type=template&id=27c3411a&scoped=true"
import script from "./AboutS4.vue?vue&type=script&lang=js"
export * from "./AboutS4.vue?vue&type=script&lang=js"

import "./AboutS4.vue?vue&type=style&index=0&id=27c3411a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c3411a"]])

export default __exports__